<template>
  <v-row :class="!hideBorderBottom && 'bb'">
    <v-col cols="5">
      {{ name }}
    </v-col>

    <v-col cols="5">
      <div class="label-text-value">
        {{ value | shortText(this) }}
      </div>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'SimpleTextRow',

  filters: {
    shortText(value, self) {
      if (self && self.textShort) {
        if (typeof value === 'number') return value
        if (!value) return ''

        if (value.length > 45) return `${value.slice(0, 45)}...`
        return value
      } return value
    },
  },

  props: {
    name: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    hideBorderBottom: {
      type: Boolean,
      default: false,
    },
    textShort: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
